var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Loading from '../Loading';
import { t } from '../../i18n';
import Completion from './Completion';
var StepSuccess = function (_a) {
    var _b, _c, _d;
    var step = _a.step;
    var _e = useSelector(function (state) { return state.form; }), form = _e.form, formInfo = _e.formInfo;
    // window.addEventListener("message", (event) => {
    //   if (!event.origin.includes("localhost"))
    //     return;
    //   if(event && event.source && event.data == "CHECK_FORM"){
    //     console.log("event.data", event.data);
    //     event.source.postMessage("SUCCESS", event.origin);
    //     console.log("sent sucess message");
    //   }
    // });
    var sendSuccessMessage = function () {
        var _a;
        var _b;
        // Verifica se é uma webview
        var customWindow = window;
        if ((_b = customWindow === null || customWindow === void 0 ? void 0 : customWindow.ReactNativeWebView) === null || _b === void 0 ? void 0 : _b.postMessage) {
            customWindow.ReactNativeWebView.postMessage("\n        {\n          message: success,\n          token: ".concat(formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding, "\n        }\n      "));
            customWindow.ReactNativeWebView.postMessage({
                message: 'success',
                token: "".concat(formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding),
            });
        }
        if (customWindow === null || customWindow === void 0 ? void 0 : customWindow.flutter_inappwebview) {
            var args = "{ \"message\": \"success\", \"token\": ".concat(formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding, " }");
            (_a = customWindow.flutter_inappwebview).callHandler.apply(_a, __spreadArray(['onResourceLoad'], [args], false));
        }
        if (window !== window.top) {
            var message = {
                message: 'success',
                token: formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding,
            };
            // Replace "*" with the actual origin of the parent window for security
            window.parent.postMessage(message, '*');
        }
    };
    useEffect(function () {
        sendSuccessMessage();
    }, []);
    if ((_b = form.steps[step].fields.find(function (i) { return i.field === 'success_text'; })) === null || _b === void 0 ? void 0 : _b.value) {
        window.parent.location.replace((_c = form.steps[step].fields.find(function (i) { return i.field === 'success_text'; })) === null || _c === void 0 ? void 0 : _c.value);
        return null;
    }
    if ((_d = form.steps[step].fields.find(function (i) { return i.field === "success_reload"; })) === null || _d === void 0 ? void 0 : _d.value) {
        alert(t('success.closingPage'));
        window.close();
        return null;
    }
    return (React.createElement(Completion, { step: step }, form.steps[step].fields.some(function (field) { return field.visible && field.field === 'success_loading'; }) && (React.createElement(Loading, { customStyle: { position: 'static', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '4rem' } }))));
};
export default StepSuccess;
